<template>
    <div style="margin-top:100px;">
        <Layout>
          <template v-slot:body>
              
          </template>
          <template v-slot:panel>
              i am panel
          </template>
        </Layout>
        <Layout>
            
        </Layout>

    </div>
</template>


<script>
import Layout from '@/components/Layout'
export default {
    components:{
        Layout
    }
}
</script>
